export const mutationTypes = {
  SET_DATA_SETTINGS: 'SET_DATA_SETTINGS',
  SET_BEFORE_STYLE_PREVIEW_MODE: 'SET_BEFORE_STYLE_PREVIEW_MODE',
  SET_ANIMATION_DATA_SETTINGS: 'SET_ANIMATION_DATA_SETTINGS',
  SET_DATA_SNIPPETS: 'SET_DATA_SNIPPETS',
  SET_ALL_DATA_SNIPPETS: 'SET_ALL_DATA_SNIPPETS',
  DELETE_DATA_SETTING_BY_KEY: 'DELETE_DATA_SETTING_BY_KEY',
  DELETE_ANIMATION_DATA_SETTING: 'DELETE_ANIMATION_DATA_SETTING',
  SHOW_SHORTCUT_MODAL: 'SHOW_SHORTCUT_MODAL',
  SET_LOADING_DYNAMIC_DATA: 'SET_LOADING_DYNAMIC_DATA',
  SET_LOADING_EDITOR: 'SET_LOADING_EDITOR',
  SET_TYPE_BLANK_PAGE: 'SET_TYPE_BLANK_PAGE',
};

export const getterTypes = {
  GET_ANIMATION_DATA: 'GET_ANIMATION_DATA',
  GET_BEFORE_STYLE_PREVIEW_MODE: 'GET_BEFORE_STYLE_PREVIEW_MODE',
  GET_ANIMATION_ACTION: 'GET_ANIMATION_ACTION',
  GET_DATA_SETTING_BY_KEY: 'GET_DATA_SETTING_BY_KEY',
  EXIST_KEY_DATA_SETTING: 'EXIST_KEY_DATA_SETTING',
  UPDATE_DATA_SETTING_BY_KEY: 'UPDATE_DATA_SETTING_BY_KEY',
  GET_ANIMATION_ACTION_SETTING_BY_KEY: 'GET_ANIMATION_ACTION_SETTING_BY_KEY',
  GET_ANIMATION_INTERACTION_SETTING_BY_KEY: 'GET_ANIMATION_INTERACTION_SETTING_BY_KEY',
  GET_SNIPPETS_BY_KEY: 'GET_SNIPPETS_BY_KEY',
  GET_STYLE_SETTINGS: 'GET_STYLE_SETTINGS', // get all styles settings
  GET_ALL_STYLES: 'GET_ALL_STYLES',
  GET_LOADING_DYNAMIC_DATA: 'GET_LOADING_DYNAMIC_DATA',
  GET_LOADING_EDITOR: 'GET_LOADING_EDITOR',
};

export type editor = {
  dataSettings: any;
  dataSnippets: any;
  animations: animations;
  showShortcutModal: boolean;
  beforeStylePreviewModeGlobalStyle: any;
  isLoadingDynamicData: boolean;
  isLoadingEditor: boolean;
  isBlankPage: boolean;
  loadFinishALLMER: boolean;
};

type animations = {
  actions: any;
  interactions: any;
};
